import { GeneralStatusHistoryDto } from "@/core/api/generated/v1";

/** Any entity DTO type according to @type EntityFormType */
export type GeneralStatusHistoryDtoAny = GeneralStatusHistoryDto;

/** All entity DTO types according to @type EntityFormType */
export type GeneralStatusHistoryDtoAll = GeneralStatusHistoryDto;

export class GeneralStatusHistoryMapper {}
